import { notify } from '../components/NotificationModal';

// Coerce any message to a safe string. Rendering a non-string (e.g. a FastAPI 422
// `detail` array of {type, loc, msg, ...} objects) as a React child throws
// React error #31 and blanks the page. This guarantees only strings reach the UI.
const toMessage = (message) => {
  if (message == null) return '';
  if (typeof message === 'string') return message;
  if (Array.isArray(message)) {
    const parts = message
      .map((m) => (typeof m === 'string' ? m : m && typeof m === 'object' ? (m.msg || '') : ''))
      .filter(Boolean);
    return parts.length ? parts.join('; ') : 'Something went wrong. Please try again.';
  }
  if (typeof message === 'object') {
    return message.msg || message.detail || message.message || 'Something went wrong. Please try again.';
  }
  return String(message);
};

export const toast = {
  success: (message) => notify.success(toMessage(message)),
  error: (message) => notify.error(toMessage(message)),
  info: (message) => notify.info(toMessage(message)),
  warning: (message) => notify.warning(toMessage(message)),
};

// No-op Toaster — rendering is handled by NotificationProvider
export const Toaster = () => null;
